import { genericGetWithParameters } from "./Networking";

export async function getCustomerQPSBalances(customerID) {
  try {
    const params = {
        'customerID': customerID
    }
    const response = await genericGetWithParameters('QPS/CustomerBalancesGet', params);
    return response;
  } catch (error) {
    console.error(error)
  }
}

export async function getBalancesReport() {
  try {
    let response = await genericGetWithParameters('QPS/CustomerBalancesForReport', null);
    return response;
  } catch (error) {
    console.error(error);
  }
}